import React from 'react'
import { SelectChangeEvent } from "@mui/material";
import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";

function useSillFinishSelector() {
    const sillFinish = useStore((state) => state.quote.sillFinish);
    const addToQuote = useStore((state) => state.addToQuote);
  
    const findRequired = useRequiredMsgs((state) => state.findRequired);
    const removeRequired = useRequiredMsgs((state) => state.removeRequired);
  
    const handleChange = (e: SelectChangeEvent<string>) => {
      addToQuote({ sillFinish: e.target.value });
      if (findRequired("Sill Dam Finish")) removeRequired("Sill Dam Finish");
    };

    return {
        handleChange,
        sillFinish
    }
}

export default useSillFinishSelector